"use client";

import { useId } from "react";

import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Sidebar } from "@/components/sidebar";
import { useStore } from "@/store";
import { useTeamChats } from "@/store/useTeamChats";
import { twMerge } from "@/utils/twMerge";

import { DirectMessagesSection } from "../direct-messages/DirectMessagesSection";
import { NavInstructions } from "../NavInstructions";
import { ChatsTrash } from "../team-chats/ChatsTrash";
import { TeamMembers } from "../team-members/TeamMembers";
import { NavTree } from "../useSidebarNav";

import { ChannelsSection } from "./ChannelsSection";
import { ChatsTabControls } from "./ChatsTabControls";

export const ChatsTab = observer(function ChatsTab() {
  const teamChats = useTeamChats();
  const { auth } = useStore();
  const t = useTranslations("documentsSidebar");
  const instructionsId = useId();

  if (!auth.isLoggedIn) {
    return null;
  }

  // The personal space has no channels or members, only direct messages
  const isTeamSpace = teamChats.isAvailable;

  return (
    <Sidebar.Group className="p-0 relative flex-col" shrink>
      {isTeamSpace && <ChatsTabControls />}
      <Sidebar.Scrollable
        as="nav"
        aria-label={isTeamSpace ? t("teamSectionsPanel") : t("chats")}
        className={twMerge("w-auto m-1.25 mt-0 rounded-8", !isTeamSpace && "mt-1.25")}
        aria-describedby={instructionsId}
      >
        <NavInstructions id={instructionsId} />
        {/* Unread section mounts here (D-3318) */}
        <NavTree aria-label={isTeamSpace ? t("teamSectionsPanel") : t("chats")}>
          {isTeamSpace && <ChannelsSection />}
          <DirectMessagesSection />
          {isTeamSpace && (
            <>
              <TeamMembers />
              <ChatsTrash />
            </>
          )}
        </NavTree>
      </Sidebar.Scrollable>
    </Sidebar.Group>
  );
});
